export default __webpack_public_path__ + "download-to-storage-drive.png";